import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { MatterUpdateMetadataRequestDto } from '../../../../backend/src/matter/dto/matter-update-metadata.request.dto';
import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useUpdateMatter = (id: string | undefined) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const updateMatter = async (data: MatterUpdateMetadataRequestDto) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data,
    });

    const response = await fetch(`${APIBaseChronos}/api/matters/${id}`, fetchConfig);
    if (!response.ok) {
      throw new Error('Error updating matter');
    }
    return await response.json();
  };

  return useMutation({
    mutationFn: updateMatter,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Matter, { matterId: id }] });
    },
    onError: (error: Error) => {
      console.error('Update matter error:', error);
      toast.error(error.message || 'Failed to update matter. Please try again.');
    },
  });
};
